import notFoundImage from '@assets/images/ai4.png';
import styles from './childrenList.module.scss';
import { Skeleton } from 'antd';
import { childListResponse } from 'src/core/repo/child/types';
import { GoChevronRight } from 'react-icons/go';

interface Props {
  items?: childListResponse[] | null;
  isLoading: boolean;
  onSelect: (children: childListResponse) => void;
}

const ChildrenList = ({ items, isLoading, onSelect }: Props) => {
  return (
    <div>
      {items?.length === 0 ? (
        <div className={styles.not_found_wrapper}>
          <img src={notFoundImage} alt="not found image" />
          <h1>Nothing found for you ...</h1>
        </div>
      ) : isLoading ? (
        <div className={styles.options}>
          {Array.from({ length: 4 }, (_, i) => (
            <Skeleton.Input className={styles.option} active key={i} />
          ))}
        </div>
      ) : (
        <div className={styles.options}>
          {items?.map((item) => (
            <div
              onClick={() => onSelect(item)}
              key={item.ChildID}
              className={styles.option}>
              <div className={styles.option_info}>
                <div className={styles.option_image}>
                  <img
                    src={`${item.PhotoURL}`}
                    width={40}
                    height={40}
                    alt={item.ChildName}
                  />
                </div>
                <div className={styles.child_info}>
                  <p>{item.ChildAge} years old</p>
                  <h2>{item.ChildName}</h2>
                </div>
              </div>
              <div className={styles.option_action}>
                <GoChevronRight size={24} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChildrenList;
